module.exports = __webpack_public_path__ + "static/media/sydney-poster.ca3e13c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/video/sydney-poster.jpg
// module id = 986
// module chunks = 0